<app-nav-menu></app-nav-menu>
<router-outlet></router-outlet>
<app-footer-menu></app-footer-menu>